module.exports = __webpack_public_path__ + "static/media/cont1402.fd99b9d.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/cont1402.mp4
// module id = JyYv
// module chunks = 0